import React from 'react';
import {Col, Form, Input, Row} from "antd";
import {attendanceGps} from "../constant/key";
import {t} from "i18next";
const TextDescription = props => {
    const { TextArea } = Input;

    return (
        <Row gutter={12}>
            <Col
                xxl={{span: 16}}
                xl={{span: 16}}
                lg={{span: 16}}>
                <Form.Item
                    label={<b>{t("tnp.setting.description")} </b>}
                    name={attendanceGps.description}

                >
                    <TextArea rows={4} placeholder={t("tnp.setting.descriptionPlaceholder")} />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default TextDescription;
